module.exports = __webpack_public_path__ + "static/media/notificacion_categoria_solicitudes_vacaciones.7852479f.png";